/**
 * @name CompleteAppointmentController
 * @description Controller for completing appointments
 * @param {library} $uibModalInstance The modal instance from UI Boostrap
 * @param {service} Appointment The appointment service
 * @param {object} appointment The appointment resolve
 * @param {object} project The project resolve
 * @param {object} shopMessageTemplates The shopMessageTemplates resolve
 * @param {library} moment The moment library
 * @param {constant} NOTIFICATIONS The notifications constant
 * @param {service} Session The Session service
 * @param {service} Notification The notification service
 * @param {service} AlertMessages The alert messages constant
 * @param {service} Project The project service
 * @param {service} FormatProject The format project service
 * @param {service} Activity The Activity service
 * @param {service} Messages The Messages service
 * @param {library} _ The Lodash library
 * @param {angular} $q The Angular $q service
 * @param {angular} $log The Angular $log service
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 */
function CompleteAppointmentController(
  $uibModalInstance,
  Appointment,
  appointment,
  project,
  shopMessageTemplates,
  moment,
  NOTIFICATIONS,
  Session,
  Notification,
  AlertMessages,
  Project,
  FormatProject,
  Activity,
  Messages,
  _,
  $q,
  $log,
  collectorWantsNotif
) {
  let vm = this;

  vm.shopMessageTemplates = shopMessageTemplates;
  vm.appointment = _.cloneDeep(appointment);
  vm.projectTmp = _.cloneDeep(project);
  vm.session = Session;
  vm.appointmentDateTime = null;
  vm.endNow = true;
  vm.currentTime = moment().format('hh:mm a');
  vm.completeAppointment = completeAppointment;
  vm.message = {
    cid: vm.appointment.conversations,
    content: null,
    private: false
  };

  determineProjectStatus();

  /**
   * @name completeAppointment
   * @description Function to complete an appointment
   */
  function completeAppointment() {
    let status = 70;

    let promises = $q.all({});

    // Check to see if the appiontment ended early
    if (vm.endNow && vm.inProgress) {
      vm.appointment.adjustedLength =
      parseInt((Math.abs(moment(vm.appointmentDateTime).unix() -
      moment().unix())) / 60, 10);
    }

    // Send the Appointment Update
    promises.appointment = Appointment.update(vm.appointment, status)
    .then(function(appointment) {
      // Send a notification to the collector
      let notificationToCollector = {
        recipients: [vm.projectTmp.collector.id],
        notificationId: NOTIFICATIONS.appointmentCompleteToCollector,
        messageObjects: {
          appointmentId: vm.appointment.id,
          projectId: vm.projectTmp.id,
          // The artist assigned to the appointment
          artistId: vm.appointment.artist.id,
          // The operator updating the appointment
          operatorId: Session.collector.id,
          // The collector who owns the project
          collectorId: vm.projectTmp.collector.id
        },
        messageVariables: {
          subject: vm.projectTmp.collector.first_name +
          ', ' + Session.collector.first_name + ' ' +
          Session.collector.last_name +
          ' completed an appointment for your project on Ink Finder',
          aftercareInstructions:
          vm.shopMessageTemplates &&
          vm.shopMessageTemplates.aftercare_instructions !== '' ?
          vm.shopMessageTemplates.aftercare_instructions : ''
        }
      };
      if (Session.activeState.association &&
      Session.activeState.association.shop.id) {
        notificationToCollector.messageObjects.shopId =
        Session.activeState.association.shop.id;
        notificationToCollector.messageVariables.subject =
        vm.projectTmp.collector.first_name +
        ', ' + Session.collector.first_name + ' ' +
        Session.collector.last_name + ' at ' +
        Session.activeState.association.shop.name +
        ' completed an appointment for your project on Ink Finder';
      }
      Notification.send(notificationToCollector);

      // Send a notification to the artist if the artist did not complete appt
      if (vm.appointment.artist.id !== Session.collector.id) {
        let notificationToArtist = {
          recipients: [vm.appointment.artist.id],
          notificationId: NOTIFICATIONS.appointmentCompleteToArtist,
          messageObjects: {
            appointmentId: vm.appointment.id,
            projectId: vm.projectTmp.id,
            // The artist assigned to the appointment
            artistId: vm.appointment.artist.id,
            // The operator updating the appointment
            operatorId: Session.collector.id,
            // The collector who owns the project
            collectorId: vm.projectTmp.collector.id
          },
          messageVariables: {
            subject: vm.appointment.artist.first_name +
            ', ' + Session.collector.first_name + ' ' +
            Session.collector.last_name +
            ' completed your appointment with ' +
            vm.projectTmp.collector.first_name
          }
        };
        if (Session.activeState.association &&
        Session.activeState.association.shop.id) {
          notificationToArtist.messageObjects.shopId =
          Session.activeState.association.shop.id;
          notificationToArtist.messageVariables.subject =
          vm.appointment.artist.first_name +
          ', ' + Session.collector.first_name + ' ' +
          Session.collector.last_name + ' at ' +
          Session.activeState.association.shop.name +
          ' completed your appointment with ' +
          vm.projectTmp.collector.first_name;
        }
        collectorWantsNotif
        .check(appointment.artist.id, appointment.shop,
        'appointment_completed', 'artist')
        .then(function(collectorWantsNotif) {
          if (collectorWantsNotif) {
            Notification.send(notificationToArtist);
          }
        });
      }
      return appointment;
    });

    // Save a message on the appointment if one exists
    if (vm.message.content !== null &&
    vm.message.content.replace(/\s/g, '').length) {
      promises.message = Messages.create(vm.message)
      .then(function(message) {
        return message;
      });
    }

    // Process all promises
    $q.all(promises).then(function(results) {
      $uibModalInstance.close(results.appointment);
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'warning'});
    });
  }

  /**
   * @name determineProjectStatus
   * @description Figure out of the Appointment is in Progress or not
   */
  function determineProjectStatus() {
    vm.appointmentDateTime =
    moment(vm.appointment.appointment_datetime);
    let length = vm.appointment.length;
    let endTime =
    moment(vm.appointmentDateTime).add(moment.duration(length).hours(),
    'hours').add(moment.duration(length).minutes(), 'minutes');
    if (moment(vm.appointmentDateTime).unix() <=
    moment().unix() && moment(endTime).unix() > moment().unix()) {
      vm.inProgress = true;
    }
  }
  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
  .module('inkfinder')
  .controller('CompleteAppointmentController', CompleteAppointmentController);



// WEBPACK FOOTER //
// ./components/appointments/appointment/complete/complete.controller.js